import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Groups from './Groups';
import DriversTable from './DriversTable';
import AddDriver from './AddDriver';
import DriverModal from './DriverModal';
import DeleteDriverModal from './DeleteDriverModal';
import { api } from '../../../../services';
import { QsHelper } from '../../../../helpers';

import './SelectableDrivers.css';

@inject('filterStore', 'translationsStore', 'commonStore', 'driversStore')
@observer
export default class SelectableDrivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      selectedGroup: 'all',
      visibleDriverModal: false,
      driverData: undefined,
      vehicleCanBeUnassigned: false
    };
  }

  componentWillUnmount() {
    this.props.filterStore.reset();
  }

  onGroupChange = () => {
    this.resetTableView();
  };

  onSelectedRowsChange = selectedRows => {
    this.setState({ selectedRows });
  };

  resetTableView = () => {
    this.setState({ selectedRows: [] });
  };

  apply = () => {
    this.props.filterStore.apply();
  };

  handleAddDriver = () => {
    this.setState({ visibleDriverModal: true, driverData: undefined, vehicleCanBeUnassigned: false });
  };

  handleEditDriver = async data => {
    let state = { visibleDriverModal: true, driverData: data, vehicleCanBeUnassigned: false };
    const hasAssignedVehicle = !!data.assignedVehicle && !!data.assignedVehicle.plate;

    if (hasAssignedVehicle) {
      const qs = new QsHelper(window.location.search),
        filters = qs.serializeObject({ driverId: data.id, status: ['not-started', 'started'] });

      await api('getRoutesTask', { filters })
        .then((response) => {
          const { count } = response;
          if (count === 0) {
            state = { ...state, vehicleCanBeUnassigned: true };
          }
        })
        .catch(() => {});
    }
    this.setState(state);
  };

  showDeleteDriver = data => {
    this.setState({ visibleDeleteDriverModal: true, driverData: data });
  };

  handleDeleteDriver = () => {
    this.props.driversStore.deleteDriver(this.state.driverData.id);
    this.changeDeleteDriverModalVisibility();
  };

  changeDriverModalVisibility = driverData => {
    this.setState(prevState => ({ visibleDriverModal: !prevState.visibleDriverModal, driverData }));
  };

  changeDeleteDriverModalVisibility = driverData => {
    this.setState(prevState => ({ visibleDeleteDriverModal: !prevState.visibleDeleteDriverModal, driverData }));
  };

  render() {
    const { drivers, driversFiltered, filterStore } = this.props;
    const { selectedRows, selectedGroup, visibleDriverModal, driverData, visibleDeleteDriverModal } = this.state;

    return (
      <div className="SelectableDrivers">
        <Groups
          drivers={drivers}
          onSelect={({ selected, group }) => {
            this.setState({ selectedGroup: selected, groupData: null });
            filterStore.remove('groupFilter');
            if (selected === 'active') {
              filterStore.add('groupFilter.group_active', driver => driver.managementStatus === 'active');
            }
            if (selected === 'notactive') {
              filterStore.add('groupFilter.group_notactive', driver => driver.managementStatus === 'notactive');
            }
            filterStore.apply();
          }}
          selected={selectedGroup}
          onGroupChange={this.onGroupChange}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }} className="content">
          <DriversTable
            drivers={driversFiltered}
            selectedRows={selectedRows}
            onSelectedRowsChange={this.onSelectedRowsChange}
            onRowEdit={this.handleEditDriver}
            onRowDelete={this.showDeleteDriver}
          />
          <AddDriver visible={true} onClick={this.handleAddDriver} />
          <DriverModal visible={visibleDriverModal} data={driverData} vehicleCanBeUnassigned={this.state.vehicleCanBeUnassigned} onDone={this.changeDriverModalVisibility} onCancel={this.changeDriverModalVisibility} />
          <DeleteDriverModal visible={visibleDeleteDriverModal} data={driverData} onCancel={this.changeDeleteDriverModalVisibility} onDelete={this.handleDeleteDriver}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/SelectableDrivers.js